import React, { useState, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import "./Invoice.css";
import { axiosInstances } from "./apiConfig";

const InvoiceQuotationEditable = ({ invoiceData, onPreview, onCancel }) => {
    const [invoiceNo, setInvoiceNo] = useState(invoiceData.invoiceNo || "");
    const [invoiceDate, setInvoiceDate] = useState(
        invoiceData.invoiceDate || new Date().toISOString().split("T")[0]
    );
    const [dueDate, setDueDate] = useState(
        invoiceData.dueDate || new Date().toISOString().split("T")[0]
    );
    const [igst, setIgst] = useState(invoiceData.igst * 100 || 0);
    const [cgst, setCgst] = useState(invoiceData.cgst * 100 || 0);
    const [sgst, setSgst] = useState(invoiceData.sgst * 100 || 0);
    const [orderId, setOrderId] = useState(invoiceData.orderId || "");
    const [orderNo, setOrderNo] = useState(invoiceData.orderNo || "");
    const [customer, setCustomer] = useState(invoiceData.customer || {});
    const [items, setItems] = useState(invoiceData.items || []);
    const [subTotal, setSubTotal] = useState(invoiceData.subTotal || 0);
    const [grandTotal, setGrandTotal] = useState(invoiceData.grandTotal || 0);
    const [inv_status, setInv_status] = useState(invoiceData.inv_status || "DRAFT");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const [company, setCompany] = useState({
        name: "My Company Pvt Ltd",
        address: "123 Main Street",
        city: "Hyderabad",
        state: "Telangana",
        zip: "500001",
        phone: "040-12345678",
        email: "info@mycompany.com",
    });

    useEffect(() => {
        if (invoiceData) {
            setInvoiceNo(invoiceData.invoiceNo || "");
            setInvoiceDate(
                invoiceData.invoiceDate || new Date().toISOString().split("T")[0]
            );
            setDueDate(
                invoiceData.dueDate || new Date().toISOString().split("T")[0]
            );
            setIgst(invoiceData.igst * 100 || 0);
            setCgst(invoiceData.cgst * 100 || 0);
            setSgst(invoiceData.sgst * 100 || 0);
            setOrderId(invoiceData.orderId || "");
            setInv_status(invoiceData.inv_status || "DRAFT")
            setCustomer(invoiceData.customer || {});
            setItems(invoiceData.items || []);
        }
    }, [invoiceData]);

    const handleCustomerChange = (e) => {
        setCustomer({ ...customer, [e.target.name]: e.target.value });
    };

    const handleItemChange = (i, field, value) => {
        const newItems = [...items];
        newItems[i][field] = value;
        setItems(newItems);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const Billing =
            customer?.addresses?.find((a) => a.addressType === "Billing") || {};
        const Shipping =
            customer?.addresses?.find((a) => a.addressType === "Shipping") || {};

        const subTotal = items.reduce(
            (sum, item) => sum + (item.quantity || 1) * (item.amount || 0),
            0
        );

        const normalizeTax = (v) => (v > 1 ? v / 100 : v);
        const newigst = normalizeTax(igst);
        const newcgst = normalizeTax(cgst);
        const newsgst = normalizeTax(sgst);

        const grandTotal = subTotal + subTotal * (newigst + newsgst + newcgst);

        onPreview({
            id: invoiceData.id || null,
            orderId,
            invoiceNo,
            invoiceDate,
            dueDate,
            company,
            productIds: items.map((item) => item.id),
            priceIds: items.map((item) => item.priceId),
            customerId: customer.id,
            customer: {
                ...customer,
                BillingAddress: Billing,
                ShippingAddress: Shipping,
            },
            items,
            igst: newigst,
            cgst: newcgst,
            sgst: newsgst,
            subTotal,
            grandTotal,
            inv_status: invoiceData.inv_status || "DRAFT",
        });
    };

    const fetchOrder = async () => {
        if (!orderNo) return;

        try {
            const resp = await axiosInstances.orderApi.post(`/getOrder`, {orderNo: orderNo});
            const data = resp.data.data;

            if (data) {
                const customer = data.customer || {};
                const addresses = customer.addresses || [];
                const Billing = addresses.find((a) => a.addressType === "Billing") || {};
                const Shipping = addresses.find((a) => a.addressType === "Shipping") || {};

                const customerInfo = {
                    id: customer.id || "",
                    name: customer.name || "",
                    email: customer.email || "",
                    phone: customer.phone || "",
                    addresses: addresses,
                    BillingAddress: Billing,
                    ShippingAddress: Shipping,
                };

                const orderItems = (data.products || []).map((p) => {
                    const priceObj = (data.prices || []).find((price) => price.productId === p.id);
                    return {
                        id: p.id,
                        code: p.id || "",
                        priceId: priceObj?.id || "",
                        description: p.description || "",
                        quantity: priceObj ? priceObj.quantity : 1,
                        amount: priceObj ? priceObj.amount : 0,
                        total: priceObj ? priceObj.amount * priceObj.quantity : 0,
                    };
                });

                setOrderId(data.order.id);
                setCompany(data.company || company);
                setCustomer(customerInfo);
                setItems(orderItems);
                setIgst(data.order.igst * 100 || 0);
                setCgst(data.order.cgst * 100 || 0);
                setSgst(data.order.sgst * 100 || 0);
                // setTerms(data.order.terms);

                setSnackbar({
                    open: true,
                    message: "✅ Order fetched successfully",
                    severity: "success",
                });
            }
        } catch (err) {
            console.error("❌ Error fetching order:", err);
            setSnackbar({
                open: true,
                message: "Failed to fetch order data",
                severity: "error",
            });
        }
    };


    return (
        <form onSubmit={handleSubmit} className="container">
            <h1 className="title">Invoice</h1>

            {/* <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
                <strong>Order ID:&nbsp;</strong>
                <input
                    type="text"
                    placeholder="Order ID"
                    value={orderId}
                    onChange={(e) => setOrderId(e.target.value)}
                    style={{ width: "100px", padding: "4px" }}
                />
                <button
                    type="button"
                    onClick={fetchOrder}
                    style={{ marginLeft: -1, height: "30px", padding: "4px 10px" }}
                >
                    🔍
                </button>
            </div> */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
                <strong>Order No:&nbsp;</strong>
                {invoiceData?.id ? (
                    <input
                        type="text"
                        value={orderNo}
                        readOnly
                        style={{
                            width: "70px",
                            marginRight: 20,
                            padding: "4px",
                            backgroundColor: "#f0f0f0",
                            cursor: "not-allowed",
                        }}
                    />
                ) : (
                    <>
                        <input
                            type="text"
                            placeholder="Order No"
                            value={orderNo}
                            onChange={(e) => setOrderNo(e.target.value)}
                            style={{ width: "100px", padding: "4px" }}
                        />
                        <button
                            type="button"
                            onClick={fetchOrder}
                            style={{ marginLeft: -1, height: "30px", padding: "4px 10px" }}
                        >
                            🔍
                        </button>
                    </>
                )}
            </div>

            <div className="header">
                <div className="company-info">
                    <h3>VENDOR:</h3>
                    {["name", "address", "city", "state", "zip", "phone", "email"].map((f) => (
                        <label key={f}>
                            {f.toUpperCase()}:
                            <input
                                type="text"
                                name={f}
                                value={company[f]}
                                onChange={(e) =>
                                    setCompany({ ...company, [e.target.name]: e.target.value })
                                }
                                className="input"
                            />
                        </label>
                    ))}
                </div>
                <div className="invoice-details">
                    <p>
                        <strong>Invoice No:</strong>{" "}
                        <input
                            type="text"
                            value={invoiceNo}
                            onChange={(e) => setInvoiceNo(e.target.value)}
                            className="input-small"
                        />
                        <br />
                        <strong>Date:</strong>{" "}
                        <input
                            type="date"
                            value={invoiceDate}
                            onChange={(e) => setInvoiceDate(e.target.value)}
                            className="input-small"
                        />
                    </p>
                </div>

                <div className="customer-info">
                    <h3>Customer:</h3>
                    {["name", "email", "phone"].map((f) => (
                        <label key={f}>
                            {f.toUpperCase()}:
                            <input
                                type="text"
                                name={f}
                                value={customer[f] || ""}
                                onChange={handleCustomerChange}
                                className="input"
                            />
                        </label>
                    ))}




                </div>

            </div>
            <div className="header">
                <div className="customer-info">
                    {/* --- Billing To --- */}
                    <div style={{ marginTop: 20, paddingTop: 10 }}>
                        <h4>BILL TO:</h4>
                        <input
                            type="text"
                            placeholder="Address Line"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.address_1 || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].address_1 = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: e.target.value,
                                        city: "",
                                        state: "",
                                        pincode: ""
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="City"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.city || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].city = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: "",
                                        city: e.target.value,
                                        state: "",
                                        pincode: ""
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="State"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.state || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].state = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: "",
                                        city: "",
                                        state: e.target.value,
                                        pincode: ""
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="Pincode"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.pincode || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].pincode = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: "",
                                        city: "",
                                        state: "",
                                        pincode: e.target.value
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                    </div>
                </div>
                <div className="customer-info">
                    {/* --- Ship To --- */}
                    <div style={{ marginTop: 20, paddingTop: 10 }}>
                        <h4>SHIP TO:</h4>
                        <input
                            type="text"
                            placeholder="Address Line"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.address_1 || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].address_1 = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: e.target.value,
                                        city: "",
                                        state: "",
                                        pincode: ""
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="City"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.city || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].city = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: "",
                                        city: e.target.value,
                                        state: "",
                                        pincode: ""
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="State"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.state || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].state = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: "",
                                        city: "",
                                        state: e.target.value,
                                        pincode: ""
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="Pincode"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.pincode || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].pincode = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: "",
                                        city: "",
                                        state: "",
                                        pincode: e.target.value
                                    });
                                setCustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                    </div>
                </div>
            </div>
            <p>
                <label>
                    <strong>Invoice Status:</strong>
                    <select
                        value={inv_status}
                        onChange={(e) => setInv_status(e.target.value)}
                    >
                        <option value="DRAFT">DRAFT</option>
                        <option value="PENDING">PENDING</option>
                        <option value="SENT">SENT</option>
                        <option value="PARTITALLY PAID">PARTITALLY PAID</option>
                        <option value="PAID">PAID</option>
                        <option value="OVERDUE">OVERDUE</option>
                        <option value="CANCELLED">CANCELLED</option>
                    </select>
                </label>
                <br />
                <strong> Due Date:</strong>{" "}
                <input
                    type="date"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                    className="input-small"
                />
            </p>


            <table className="table">
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Description</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, i) => (
                        <tr key={i}>
                            <td>
                                <input
                                    value={item.code}
                                    onChange={(e) => handleItemChange(i, "code", e.target.value)}
                                    className="input-table"
                                />
                            </td>
                            <td>
                                <input
                                    value={item.description}
                                    onChange={(e) =>
                                        handleItemChange(i, "description", e.target.value)
                                    }
                                    className="input-table"
                                />
                            </td>
                            <td>
                                <input
                                    // type="number"
                                    value={item.quantity}
                                    onChange={(e) =>
                                        handleItemChange(i, "quantity", e.target.value)
                                    }
                                    className="input-table"
                                />
                            </td>
                            <td>
                                <input
                                    // type="number"
                                    value={item.amount}
                                    onChange={(e) =>
                                        handleItemChange(i, "amount", e.target.value)
                                    }
                                    className="input-table"
                                />
                            </td>
                            <td>{(item.quantity * item.amount).toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div>
                {(customer?.addresses?.find((a) => a.addressType === "Shipping")?.state || "")
                    .trim()
                    .toLowerCase() === "telangana" ?
                    (<label>
                        IGST (%): <input value={igst} onChange={(e) => setIgst(e.target.value)} />
                    </label>) : (
                        <>
                            <label>
                                CGST (%): <input value={cgst} onChange={(e) => setCgst(e.target.value)} />
                            </label>
                            <br />
                            <label>
                                SGST (%): <input value={sgst} onChange={(e) => setSgst(e.target.value)} />
                            </label>
                        </>
                    )}
            </div>
            <br />

            <div style={{ marginTop: 30, textAlign: "center" }}>
                <button type="submit" className="save-button">
                    Preview Invoice
                </button>{" "}
                {onCancel && (
                    <button type="button" onClick={onCancel} className="cancel-button">
                        Cancel
                    </button>
                )}
            </div>
        </form>
    );
};

export default InvoiceQuotationEditable;
